import React from 'react';
import { Button, Divider, Form, Input, InputNumber, Flex, Radio, message } from 'antd';
import Geo from '../../components/geo';
import { getCurrentShopId } from '../shop/get-current-shop';
import SwitchShop from '../shop/switch-shop';

export default () => {
    const [form] = Form.useForm();
    const params = new URLSearchParams(window.location.search);
    const [geoDefaultValue, setGeoDefaultValue] = React.useState(null);
    const customerId = params.get('customerId');

    React.useEffect(() => {
        if(params.get('action') === 'edit' && params.get('customerId')) {
            getCurrentShopId().then(res => {
                initForm(res);
            });
        }
    }, []);

    const initForm = async (currentShopId) => {
        if (params.get('action') !== 'edit' || !currentShopId) return;

        const detail = await getCustomerDetail(currentShopId);
        if (!detail) return;

        const geo = [null, null, null];
        if (detail.province) {
            geo[0] = { name: detail.province, adcode: detail.provinceCode };
        }
        if (detail.city) {
            geo[1] = { name: detail.city, adcode: detail.cityCode };
        }
        if (detail.county) {
            geo[2] = { name: detail.county, adcode: detail.countyCode };
        }

        setGeoDefaultValue(geo);
        form.setFieldsValue({
            ...detail,
            geo,
        });
    };

    const getCustomerDetail = async (currentShopId) => {
        const res = await fetch(`/api/customer/detail?shopId=${currentShopId}&customerId=${params.get('customerId')}`);
        const data = await res.json();
        return data.success ? data.data : null;
    };

    const onFinish = async (values) => {
        const shopId = await getCurrentShopId();
        if (!shopId) {
            message.error('未获取到店铺信息');
            return;
        }

        values.shopId = shopId;

        if (values.geo && values.geo.length > 0) {
            values.province = values.geo?.[0]?.name || '';
            values.provinceCode = values.geo?.[0]?.adcode || '';
            values.city = values.geo?.[1]?.name || '';
            values.cityCode = values.geo?.[1]?.adcode || '';
            values.county = values.geo?.[2]?.name || '';
            values.countyCode = values.geo?.[2]?.adcode || '';
            delete values.geo;
        }

        const url = customerId && params.get('action') === 'edit' ? `/api/customer/create?customerId=${customerId}` : '/api/customer/create';

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(values),
        });

        const result = await response.json();

        if (result?.success) {
            message.success('提交成功');
            setTimeout(() => {
                window.location.href = '/customer';
            }, 200);
        } else {
            message.error(result?.data || '提交失败');
        }
    };

    return (
        <div>
            <main className="admin-main-content admin-content">
                <SwitchShop />
                
                <h2 className="admin-page-title">{customerId && params.get('action') === 'edit' ? '编辑客户' : '创建客户'}</h2>
                
                <div className="admin-form-container">
                    <Form form={form} onFinish={onFinish} layout="vertical">
                        <Form.Item
                            label="客户名称"
                            name="username"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入客户名称',
                                },
                            ]}
                        >
                            <Input className="admin-form-input" placeholder="请输入客户名称" />
                        </Form.Item>

                        <Form.Item
                            label="客户手机"
                            name="phoneNo"
                        >
                            <InputNumber className="admin-form-input w-full" placeholder="请输入手机号" style={{ width: '100%' }} />
                        </Form.Item>

                        <Form.Item
                            label="性别"
                            name="sex"
                        >
                            <Radio.Group
                                options={[
                                    { value: 1, label: '男' },
                                    { value: 0, label: '女' },
                                ]}
                                className="w-full"
                            />
                        </Form.Item>

                        <Form.Item
                            label="省市区"
                            name="geo"
                        >
                            <Geo defaultValue={geoDefaultValue} />
                        </Form.Item>

                        <Form.Item
                            label="详细地址"
                            name="address"
                        >
                            <Input className="admin-form-input" placeholder="请输入详细地址" />
                        </Form.Item>

                        <Form.Item
                            label="备注"
                            name="remark"
                        >
                            <Input className="admin-form-input" placeholder="请输入备注信息" />
                        </Form.Item>

                        <div className="admin-form-actions">
                            <Button href='/customer'>
                                取消
                            </Button>

                            <Button type="primary" htmlType="submit">
                                提交
                            </Button>
                        </div>
                    </Form>
                </div>
            </main>
        </div>
    );
};